import React from 'react';

const Services = () => {
  return (
    <section className="section" id='services'>
    
    <div className="container mx-auto px-16">
      
    <div className='flex flex-col lg:flex-row justify-between'>
      <div className='flex flex-col'>
      <h2 className='h2 text-accent underline'>Education</h2>
      <ul className="flex flex-col space-y-2">
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">Tezpur University</h3>
          <p className="text font-semibold">B.Tech in Computer Science & Engineering</p>
          <p className="text font-semibold">2021-25</p>
        </div>
      </div>
          </div>
        </li>
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">TRB Junior College</h3>
          <p className="text font-semibold">Class 12</p>
          <p className="text font-semibold">2019-21</p>
        </div>
      </div>
          </div>
        </li>
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">Holy Name School</h3>
          <p className="text font-semibold">Class 10</p>
          <p className="text font-semibold">2006-18</p>
        </div>
      </div>
          </div>
        </li>
      </ul>

     
      </div>
      <div className='flex flex-col'>
      <h2 className='h2 text-accent underline'>Experience</h2>
      <ul className="flex flex-col space-y-2">
      <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">XopunTech(India) pvt Limited</h3>
          <p className="text font-semibold italic">Software Developer Intern</p>
          <p className="text font-semibold">Jun 2024 - Aug 2024</p>
          <p>Developed AlgoQuest, a coding practice platform inspired by LeetCode, using React.js, enabling users to solve algorithmic problems in a split-screen interface with real-time code execution and output display.</p>
        </div>
      </div>
          </div>
        </li>
        
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">Dabotics India pvt Limited</h3>
          <p className="text font-semibold italic">Web Developer Intern</p>
          <p className="text font-semibold">Jan 2024 - Feb 2024</p>
          <p>Collaborated with team members to deliver project features within deadlines and assisted in developing web-based applications using HTML, CSS, JavaScript. Also participated in testing and bug fixing</p>


        </div>
      </div>
          </div>
        </li>
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">Aikdhi India</h3>
          <p className="text font-semibold italic">Frontend Developer Intern</p>
          <p className="text font-semibold">Aug 2023 - Sep 2023</p>
          <p>I was part of the Development team of Aikdhi official website development. My role was to develop and design the frontend of their website. I worked on small web modules and UI features, focusing on functionality and responsiveness.</p>

          
        </div>
      </div>
          </div>
        </li>
      </ul>

     
      </div>
      </div>
    </div>
  </section>);
};

export default Services;
